var _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNewEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 4,
    height: 8,
    fill: "#CBA67A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 14,
    width: 4,
    height: 6,
    fill: "#CBA67A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 2,
    width: 4,
    height: 7,
    fill: "#CBA67A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 16,
    width: 4,
    height: 4,
    fill: "#CBA67A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 12,
    width: 4,
    height: 1,
    fill: "#CBA67A"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 11.5,
    y: 14.5,
    width: 4,
    height: 1,
    transform: "rotate(-90 11.5 14.5)",
    fill: "#CBA67A"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 16,
    width: 4,
    height: 6,
    fill: "#CBA67A"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 6,
    width: 4,
    height: 8,
    fill: "#CBA67A"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewEdit);
export default __webpack_public_path__ + "static/media/new-edit.95eff2c83a62ce19f8b2399fd2d862d7.svg";
export { ForwardRef as ReactComponent };